class CancelableFuture {
    static CanceledError = class extends Error {
        constructor(message = "Action Cancelled", ...args) {
            super(message, ...args);
            this.name = 'CanceledError';
        }
    }
    static States = Object.freeze({
        PENDING: Symbol('pending'),
        RESOLVED: Symbol('resolved'),
        REJECTED: Symbol('rejected'),
        CANCELLED: Symbol('cancelled'),
    });
    #_promise;
    #_resolveFn;
    #_rejectFn;
    #_onCancelFn;
    #_futureState = CancelableFuture.States.PENDING;
    constructor(onCancelFn = function () { }) {
        this.#_onCancelFn = onCancelFn;
        this.#_promise = new Promise((resolve, reject) => {
            this.#_resolveFn = resolve;
            this.#_rejectFn = reject;
        });
    }
    get promise() {
        return this.#_promise;
    }
    resolve(value) {
        if (this.isPending()) {
            this.#_futureState = CancelableFuture.States.RESOLVED;
            this.#_resolveFn(value);
        }
        else {
            throw new Error(`Cannot resolve a previously ${this.#_futureState.description} future.`);
        }
    }
    reject(error) {
        if (this.isPending()) {
            if (error?.__proto__ === CancelableFuture.CanceledError.prototype) {
                this.#_futureState = CancelableFuture.States.CANCELLED;
            }
            else {
                this.#_futureState = CancelableFuture.States.REJECTED;
            }
            this.#_rejectFn(error);
        }
        else {
            throw new Error(`Cannot reject a previously ${this.#_futureState.description} future.`);
        }
    }
    async cancel(reason) {
        if (this.isPending()) {
            this.reject(new CancelableFuture.CanceledError(reason));
            if (Object.prototype.toString.call(this.#_onCancelFn) === `[object Function]`) {
                await this.#_onCancelFn(reason);
            }
        }
        else {
            throw new Error(`Cannot cancel a previously ${this.#_futureState.description} future.`);
        }
    }
    isPending() {
        if (this.#_futureState === CancelableFuture.States.PENDING) {
            return true;
        }
        else {
            return false;
        }
    }
    isResolved() {
        if (this.#_futureState === CancelableFuture.States.RESOLVED) {
            return true;
        }
        else {
            return false;
        }
    }
    isRejected() {
        if (this.#_futureState === CancelableFuture.States.REJECTED) {
            return true;
        }
        else {
            return false;
        }
    }
    isCancelled() {
        if (this.#_futureState === CancelableFuture.States.CANCELLED) {
            return true;
        }
        else {
            return false;
        }
    }
}

export { CancelableFuture };
export default CancelableFuture;